<div class="season-header d-flex justify-content-between" [class.grid]="isGridLayout()">
  <p class="season-description">{{ vm.seasonDescription }}</p>
  <osn-shared-episode-list-layout-toggle [formControl]="episodeLayoutControl"></osn-shared-episode-list-layout-toggle>
</div>
<div #episodes class="episodes" [class.grid]="isGridLayout()">
  <ng-container *ngFor="let episode of vm.episodes; let index = index">
    <div
      class="episode-item"
      [class.grid]="isGridLayout()"
      data-testid="SeriesDetailsPage.episode"
      (click)="onEpisodeListItemClicked(episode)"
      [class.disabled]="!isEpisodeAvailable(episode)"
    >
      <div *ngIf="!isGridLayout()" class="episode-number d-none d-sm-flex align-items-center justify-content-center">
        {{ index + 1 }}
      </div>
      <div
        class="episode-image-container"
        [attr.data-testid]="index === 0 ? 'SeriesDetailsPage.firstEpisode' : 'SeriesDetailsPage.episode'"
        (click)="onEpisodeGridItemThumbnailClicked(episode)"
      >
        <div class="episode-image">
          <img
            osnSharedUseAsPicture
            [src]="episode.backgroundUrl"
            [alt]="episode.title"
            [imgQuery]="imgQuery"
            data-testid="SeriesDetailsPage.episodeImage"
          />
          <div class="episode-progress">
            <ng-container *ngIf="isGridLayout() || (isMobile$ | async); else playIcon">
              <ng-container *ngTemplateOutlet="episodeTitle"></ng-container>
            </ng-container>
            <osn-shared-progress-bar
              *ngIf="episode.elapsedInSeconds"
              [lengthInSeconds]="episode.lengthInSeconds"
              [elapsedInSeconds]="episode.elapsedInSeconds"
              theme="white"
            ></osn-shared-progress-bar>
          </div>
        </div>
        <div *ngIf="(isMobile$ | async) || isGridLayout()" class="carousel-item-blur"></div>
      </div>
      <div
        *ngIf="isGridLayout() || (isMobile$ | async)"
        class="episode-description-wrapper"
        [@expandAnimation]="openedEpisodeListItem === episode ? 'open' : 'close'"
        [class.closed]="openedEpisodeListItem !== episode"
        (click)="toggleDescription($event, episode)"
      >
        <p class="episode-description mt-2">{{ episode.description }}</p>
        <div class="gradient"></div>
      </div>
      <div *ngIf="!(isMobile$ | async)" class="episode-metadata">
        <ng-container *ngTemplateOutlet="episodeTitle"></ng-container>
        <p class="episode-description mt-2 mt-lg-3 mt-xl-4">{{ episode.description }}</p>
      </div>
      <ng-template #episodeTitle>
        <div class="episode-title" data-testid="SeriesDetailsPage.episodeTitle">
          <div class="episode-title-texts d-flex flex-column">
            <h3 class="episode-title-text">
              {{
                'SD_EpisodeList_Item_Title_Txt'
                  | translate: { season: episode.seasonNumber, number: episode.episodeNumber, title: episode.title }
              }}
            </h3>
            <span class="episode-title-subtext" *ngIf="episode.lengthInSeconds">{{ episode.lengthInSeconds | secondsToHour }}</span>
          </div>
          <svg-icon class="play-icon mb-1" key="play"></svg-icon>
        </div>
      </ng-template>
    </div>
    <div *ngIf="index === bannerPosition && vm.marketingBannerViewModel && !isGridLayout()" class="mb-3 my-sm-3 my-lg-4 my-xl-5 pb-sm-2">
      <osn-shared-marketing-banner
        [vm]="vm.marketingBannerViewModel"
        (marketingBannerButtonClick)="onMarketingBannerButtonClick(vm.marketingBannerViewModel?.primaryButton.labelLocalized.en)"
      ></osn-shared-marketing-banner>
    </div>
  </ng-container>
  <div #intersectionBoundary class="intersection-boundary"></div>
</div>

<ng-template #playIcon>
  <svg-icon class="play-icon" key="play"></svg-icon>
</ng-template>
